import { render, staticRenderFns } from "./DepartmentMain.vue?vue&type=template&id=8531fd80&scoped=true"
import script from "./DepartmentMain.vue?vue&type=script&lang=js"
export * from "./DepartmentMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8531fd80",
  null
  
)

export default component.exports